module.exports = __webpack_public_path__ + "static/media/993820.f95d95fb.png";